import { render, staticRenderFns } from "./SystemMessages.vue?vue&type=template&id=01525b09&"
import script from "./SystemMessages.vue?vue&type=script&lang=js&"
export * from "./SystemMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SystemMessages.vue"
export default component.exports